import { render, staticRenderFns } from "./AdminChatIframe.vue?vue&type=template&id=06412ce0&scoped=true&"
import script from "./AdminChatIframe.vue?vue&type=script&lang=js&"
export * from "./AdminChatIframe.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatIframe.vue?vue&type=style&index=0&id=06412ce0&prod&lang=css&"
import style1 from "./AdminChatIframe.vue?vue&type=style&index=1&id=06412ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06412ce0",
  null
  
)

export default component.exports